import { inject, NgModule } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { AuthService } from '@interacta-shared/data-access-auth';
import { ConfigurationService } from '@interacta-shared/data-access-configuration';
import { isDefined } from '@interacta-shared/util';
import { LicenceType } from '@interacta-shared/util-common';
import {
    BOTTOM_MENU_ITEM_IDS,
    BottomMenuService,
} from '@interacta/feature-bottom-menu';
import { AppSelectors, AppState } from '@modules/core/store';
import { ChatStateService } from '@modules/state/services/chat-state.service';
import { StateService } from '@modules/state/services/state.service';
import { Store } from '@ngrx/store';
import { combineLatest, filter, map, switchMap } from 'rxjs';
import { ChatPanelComponent } from './components/chat-panel/chat-panel.component';

@NgModule({})
export class ChatModule {
    private readonly stateService = inject(StateService);

    private readonly chatIsOpen = toSignal(
        this.stateService.chatState.isOpen$,
        { requireSync: true },
    );
    constructor(
        private bottomMenuService: BottomMenuService,
        private authService: AuthService,
        private chatStateService: ChatStateService,
        private configurationService: ConfigurationService,
        private store: Store<AppState>,
    ) {
        const selectedRouteState$ = this.store.select(
            AppSelectors.selectRouteState,
        );

        toObservable(this.configurationService.environmentInfo)
            .pipe(
                filter(isDefined),
                switchMap((envInfo) =>
                    combineLatest([
                        this.authService.currentUserData$,
                        selectedRouteState$,
                    ]).pipe(
                        map(([userData, selectedRouteState]) => ({
                            envInfo,
                            userData,
                            selectedRouteState,
                        })),
                    ),
                ),
            )
            .subscribe(({ envInfo, userData, selectedRouteState }) => {
                const chatEnabled =
                    envInfo?.installedFeatures.chat &&
                    envInfo?.installedFeatures.chatEmbedded &&
                    userData?.licences?.some(
                        (value) => value.type === LicenceType.CHAT,
                    ) &&
                    selectedRouteState?.appBaseRoute !== 'error';

                this.chatStateService.toggleEnable(chatEnabled ?? false);

                if (chatEnabled) {
                    this.bottomMenuService.addComponent(
                        {
                            id: BOTTOM_MENU_ITEM_IDS.CHAT_PANEL,
                            type: ChatPanelComponent,
                            isOpen: this.chatIsOpen,
                        },
                        true,
                    );
                } else {
                    this.bottomMenuService.removeComponent(ChatPanelComponent);
                }
            });
    }
}
